import { render, staticRenderFns } from "./KeyBinder.vue?vue&type=template&id=10600480&"
import script from "./KeyBinder.vue?vue&type=script&lang=js&"
export * from "./KeyBinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports